import React from "react";

const Button = props => (
  <div id="button" className="row">
    <button {...props}>{props.title}</button>
  </div>
)
export default Button